<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import DefaultWhiteCard from "@/components/global-themed/ui/sections/DefaultWhiteCard.vue";
import HeadingTitle from "@/components/website/v2/ui/HeadingTitle.vue";
import KitIcon from "@/components/approval-center/partials/kit/KitIcon.vue";
import SectionText from "@/components/website/v2/ui/SectionText.vue";
import SectionBorderedWrapper from "@/components/website/v2/ui/SectionBorderedWrapper.vue";
import SectionSubText from "@/components/website/v2/ui/SectionSubText.vue";
import {ref} from "vue";
import KitShadow from "@/components/website/v2/ui/KitShadow.vue";
import {useMutation} from "@tanstack/vue-query";
import axios from "axios";
import DefaultUrlInput from "@/components/global-themed/inputs/DefaultUrlInput.vue";
import {nextStep, useCreateWebsite} from "@/composables/website/v2/useCreateWebsite";

const inputRef = ref(null);
const {websiteUrl} = useCreateWebsite();

const {mutate: handleSubmit, isPending} = useMutation({
  mutationFn: () => axios.post(`/ajax/website/validate`, {
    website: websiteUrl.value
  }),
  onError: (error) => {
    inputRef.value.setErrors(error.response?.data?.message);
  },
  onSuccess: () => {
    nextStep();
  }
});
</script>

<template>
  <DefaultWhiteCard>
    <div class="tw-flex tw-flex-col tw-gap-y-16 tw-items-center">
      <HeadingTitle>Hi. I’m Kit, your new SEO expert 👋</HeadingTitle>
      <div class="tw-flex tw-flex-col tw-gap-y-8 tw-items-center">
        <div class="tw-flex tw-flex-col tw-items-center tw-gap-4">
          <KitIcon
            state="success"
            class="tw-w-32"
          />
          <KitShadow />
        </div>
        <SectionBorderedWrapper>
          <SectionText>
            I’ll be managing your SEO using Hike’s powerful tools to help you get more traffic and visibility. Let’s get
            started!
          </SectionText>

          <div class="tw-space-y-5">
            <SectionSubText>
              First, I need your website’s URL so I can begin analyzing it right away:
            </SectionSubText>

            <div class="tw-flex tw-gap-4 tw-items-center">
              <DefaultUrlInput
                ref="inputRef"
                v-model="websiteUrl"
                placeholder="Website URL"
                @keyup.enter="handleSubmit"
              />
              <DefaultButton
                :disabled="isPending"
                @click="handleSubmit"
              >
                Submit
              </DefaultButton>
            </div>
          </div>
        </SectionBorderedWrapper>
      </div>
    </div>
  </DefaultWhiteCard>
</template>

